import { render } from "./BrochureView.vue?vue&type=template&id=4cdd377b"
import script from "./BrochureView.vue?vue&type=script&lang=js"
export * from "./BrochureView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__